<template>
  <div>
    <v-overlay opacity="1" color="white" style="text-align: center;">
      <v-progress-circular
        indeterminate
        size="64"
        style="display: inline-block;"
      ></v-progress-circular>
      <div class="mt-4">
        画面が切り替わらない場合は、スマホアプリから再度お試しください。<br />
        再度試しても切り替わらない場合は、システム管理者へお問い合わせください。
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {
  created() {
    this.login();
  },

  methods: {
    /**
     * クエリ解析 & ログイン
     * エラー発生時、画面はそのままとなる
     */
    login() {
      // クエリ解析
      var queries = this.getUrlQueries();

      //ログイン処理
      this.$cognito
        .login(
          decodeURIComponent(queries.id),
          decodeURIComponent(queries.password),
          false
        )
        .then(() => {
          // ログイン成功後、画面遷移
          this.$router.push(`/car/register/app/${queries.car_id}`);
        })
        .catch();
    },

    getUrlQueries() {
      var queryStr = window.location.search.slice(1); // 文頭?を除外
      var queries = {};

      // クエリがない場合は空のオブジェクトを返す
      if (!queryStr) {
        return queries;
      }

      // クエリ文字列を & で分割して処理
      queryStr.split("&").forEach(function(queryStr) {
        // = で分割してkey,valueをオブジェクトに格納
        var queryArr = queryStr.split("=");
        queries[queryArr[0]] = queryArr[1];
      });

      return queries;
    }
  }
};
</script>
